import CloseIcon from '@mui/icons-material/Close';
import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined';
import { IconButton, Slide, Snackbar } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { metaSliceSelectors } from 'redux/slices/metaSlice';
import StyledAlert from 'toolkit/alerts/styled-alert';

import './toast.scss';

const ToastPortal = () => {
  const [domReady, setDomReady] = useState(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toast = metaSliceSelectors.useSelectToastConfig();

  function handleClose() {
    setIsOpen(false);
  }

  useEffect(() => {
    setDomReady(true);
  }, []);

  useEffect(() => {
    if (toast.message && toast.severity) {
      setIsOpen(true);
    }
  }, [toast]);

  return domReady
    ? createPortal(
        <Snackbar
          open={isOpen}
          onClose={handleClose}
          autoHideDuration={3000}
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'bottom',
          }}
          TransitionComponent={Slide}
          sx={{ zIndex: 9999 }}
        >
          <div className="snackbar__alert-container">
            <StyledAlert
              message={toast?.message || ''}
              variant="filled"
              severity={toast?.severity || 'info'}
              actions={
                <Fragment>
                  {toast?.details && (
                    <IconButton
                      aria-label="Copy details to clipboard"
                      onClick={() => {
                        void navigator.clipboard.writeText(
                          JSON.stringify(toast.details, undefined, 2)
                        );
                      }}
                    >
                      <ContentPasteOutlinedIcon />
                    </IconButton>
                  )}
                  <IconButton
                    aria-label="Dismiss alert"
                    onClick={() => handleClose()}
                  >
                    <CloseIcon />
                  </IconButton>
                </Fragment>
              }
            />
          </div>
        </Snackbar>,
        document.getElementById('toast-portal')
      )
    : null;
};

export default ToastPortal;
